<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="dialog"
        :close-on-confirm="false"
        :cons="cons"
        hide-confirm
        max-width="640"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-item-spacial-category-edit-add`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="ویرایش/افزودن دسته‌بندی ویژه"
          />
        </template>
        <special-category-editor
          ref="cat-editor"
          v-model="computedValue"
          :errors="errors"
        />

        <v-card-actions>
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              :loading="false"
              class="btn btn-accept rounded-lg contentinfo"
              depressed
              @click="submitContent"
            >
              <v-icon left>mdi-content-save-plus-outline</v-icon>
              ذخیره دسته‌بندی
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-item-submitContent`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="ذخیره دسته‌بندی"
            />
          </div>
        </v-card-actions>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import SpecialCategoryEditor from "@/view/components/adapters/specialCategory/specialCategoryEditor.vue";
import { mapState } from "vuex";

export default {
  name: "makeSpecialCategory",

  components: { SpecialCategoryEditor },

  props: {
    value: Object,
    show: Boolean,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "makespecialcategory",
      cons: {
        title: "ویرایش/افزودن دسته‌بندی ویژه",
        buttons: [{ type: "close", handler: () => this.$emit("close") }],
      },
      loading: false,
      errors: {},
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    dialog: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    isModelList() {
      return this.$route.name.toLowerCase().includes("model");
    },
  },

  methods: {
    submitContent() {
      if (!this.$refs["cat-editor"]?.canSubmit)
        return this.$toast.error("فیلدها به درستی وارد نشده‌اند!");

      if (this.isModelList) {
        this.computedValue = {
          ...this.$refs["cat-editor"].temp_content,
          products: [],
        };

        this.$root.$emit("fetchSpecialCategory");
        this.dialog = false;
      } else {
        this.loading = true;

        this.$api
          .post("v1/testQr/category-special", {
            ...this.computedValue,
            ...this.$refs["cat-editor"].temp_content,
            qr_id: this.createQrID,
          })
          .then(({ data }) => {
            this.computedValue = {
              ...data.data,
              products: [],
            };
            this.$root.$emit("fetchSpecialCategory");
            this.dialog = false;
          })
          .catch(({ response }) => {
            this.errors = response?.data?.errors || {};

            if (response?.data?.message)
              this.$toast.error(response.data.message);
          })
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>
